import axios from 'axios';
import Logger from '@/Logger';

const logger = new Logger('stringsStore', 'Actions');

export default {
  // getStrings takes an optional parameter 'lang'.
  // Here we can pass the language settings from meStore to get the prefered lang.
  getStrings({ commit }, lang) {
    return new Promise(async (resolve, reject) => {
      try {
      // Fallback to empty string when lang is undefined.
        lang = lang || '';
        const response = await axios.get(`lang/${lang}`);

        // Log action and status.
        logger.info('getStrings', 'Response', response.data);

        // Commit the strings and current language info.
        commit('updateStrings', response.data.strings);

        commit('updateLanguage', lang);

        // Resolve promise
        resolve();

      // Catch errors
      } catch (error) {
      // Log action and status.
        console.warn(error);
        // Reject promise
        reject(error);
      }
    });
  },
};
